export const PageDataState = {
    Searchs: {
        enroll_key: {
            type: 'text',
            id: 'enroll_key',
            label: 'Enroll Key',
            value: '',
            placeholder: 'Enroll Key',
        },
        official_course_code: {
            type: 'text',
            id: 'official_course_code',
            label: 'รหัสหลักสูตร',
            value: '',
            placeholder: 'รหัสหลักสูตร',
        },
        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ชื่อผู้เข้าอบรม',
            value: '',
            placeholder: 'ชื่อผู้เข้าอบรม',
        }, 
        course_status: {
            type: 'select',
            id: 'course_status',
            label: 'การอบรม',
            value: '',
            placeholder: 'การอบรม',
        },  
        external_id: {
            type: 'text',
            id: 'external_id',
            value: '',
            label: 'รหัสผู้ใช้งานภายนอก',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },     
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        enroll_key: {
            type: 'text',
            id: 'enroll_key',
            label: 'Enroll Key',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        external_id: {
            type: 'text',
            id: 'external_id',
            value: '',
            label: 'รหัสผู้ใช้งานภายนอก',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },   
    },
    InputGroup: {}
}    